'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _JQueryBackend = require('./services/JQueryBackend.service');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_JQueryBackend).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/react-dnd-jquery-backend/lib/index.js
// module id = 1224
// module chunks = 0